type QueryObject = {
    [key: string]: string;
};

export const buildPathWithQuery = (path: string, query: QueryObject) => {
    const hasQuery = path.includes('?');

    const queryString = Object.keys(query)
        .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(query[k])}`)
        .join('&');

    return `${path}${hasQuery ? '&' : '?'}${queryString}`;
};
